import React from 'react';
import { MessageSquare, Brain } from 'lucide-react'; // Eliminamos Menu y X
import * as LucideIcons from 'lucide-react'; // Mantenemos si usas otros iconos de Lucide

const BannerAsistente = ({ assistantConfig, chatIndex, chatLabel, lastActivity, setSidebarVisible, sidebarVisible, hasActiveChat }) => {
  const title = hasActiveChat && assistantConfig
    ? `${assistantConfig.label} - ${chatLabel}`
    : "Edutech Pulse Lab"; // Si no hay chat activo, muestra "Edutech Pulse Lab" como título principal

  const subtitle = hasActiveChat
    ? `Última interacción: ${lastActivity}`
    : "Explora la Inteligencia Artificial para la Educación"; // Subtítulo para el estado inicial

  const getLucideComponent = (iconName) => {
    const IconComponent = LucideIcons[iconName];
    return IconComponent || MessageSquare;
  };

  const AssistantIconComponent = hasActiveChat && assistantConfig?.icon
    ? getLucideComponent(assistantConfig.icon)
    : null;

  return (
    <div className="bg-white p-4 shadow-sm border-b border-gray-100">
      <div className="flex items-center justify-between">
        {/* Contenedor del logo y el título/subtítulo */}
        <div className="flex items-center gap-3">
          {/* Logo de Edutech Pulse Lab */}
          {/* Usamos una ruta relativa desde la raíz, ya que está en public/assets */}


          {/* Si tienes un asistente activo y su ícono, lo mostramos.
              Si quieres que el logo reemplace este ícono del asistente,
              entonces puedes eliminar el bloque de abajo. */}
          {AssistantIconComponent && (
            <AssistantIconComponent className={`w-6 h-6 text-${assistantConfig.color}-800 flex-shrink-0`} />
          )}

          {/* Título y subtítulo */}
          <div className="flex flex-col min-w-0">
            <h2 className="text-base font-semibold text-gray-800 truncate">
              {title}
            </h2>
            <p className="text-xs text-gray-500 truncate">
              {subtitle}
            </p>
          </div>
        </div>

        {/* El espacio a la derecha para el diamante/otros botones ha sido eliminado completamente */}

      </div>
    </div>
  );
};

export default BannerAsistente;